import { IConsent, IConsentsValuesObject } from "../models/consent.model";

export function getConsentsInitialValues(consents: IConsent[]): IConsentsValuesObject {
    let values: IConsentsValuesObject = {}
    consents.forEach(consent => {
        values[`consent${consent.consentId}`] = {
            consentId: consent.consentId,
            value: false,
        }
    })
    return values;
}